import { DataLayer } from "@yardzen-inc/data-layer";
import LogRocket from "logrocket";
import { GoogleAnalyticsCheckoutObject } from "../../../util";
import { imageUrlForPackageName } from "../../../util/constants/packageTypes";

interface sendBeginCheckoutEventArgs {
  productObject: GoogleAnalyticsCheckoutObject;
  dataLayer: DataLayer;
  urlPackageName?: string | null;
}

export const sendBeginCheckoutEvent = ({
  productObject,
  dataLayer,
}: sendBeginCheckoutEventArgs) => {
  try {
    const beginCheckoutEvent = {
      event: "begin_checkout",
      ecommerce: {
        currency: "USD",
        value: parseFloat(productObject.price),
        items: [
          {
            item_variant_id: productObject.lotSize || "standard",
            item_id: productObject.name,
            item_name: productObject.name,
            price: parseFloat(productObject.price),
            discount: 0,
            image_url: imageUrlForPackageName[productObject.name] || "",
            item_category_id: 536, // Home & Garden
          },
        ],
      },
    };
    dataLayer.pushEvent(beginCheckoutEvent);
  } catch (error) {
    console.error(`Error sending to Google Analytics`);
    LogRocket.captureMessage(
      `Error sending order ${productObject.name} to Google Analytics`
    );
  }
};
